"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATE_STATUS_SUCCESS = exports.VALIDATE_STATUS_ERROR = exports.VALIDATE_ICONS = exports.SCROLL_SPACE = exports.MAX_HEIGHT = exports.LOCALE = exports.KEY_CODE = exports.INPUT_VARIANT = exports.HIGHTLIGHT_COLOR = exports.DEFAULT_ICON_COLOR = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _VALIDATE_ICONS;

var DEFAULT_ICON_COLOR = 'greyDark';
exports.DEFAULT_ICON_COLOR = DEFAULT_ICON_COLOR;
var INPUT_VARIANT = {
  disabled: 'disabled',
  error: 'error',
  focused: 'focused'
};
exports.INPUT_VARIANT = INPUT_VARIANT;
var VALIDATE_STATUS_SUCCESS = 'success';
exports.VALIDATE_STATUS_SUCCESS = VALIDATE_STATUS_SUCCESS;
var VALIDATE_STATUS_ERROR = 'error';
exports.VALIDATE_STATUS_ERROR = VALIDATE_STATUS_ERROR;
var VALIDATE_ICONS = (_VALIDATE_ICONS = {}, (0, _defineProperty2.default)(_VALIDATE_ICONS, VALIDATE_STATUS_SUCCESS, {
  name: 'CheckIcon',
  color: 'tertiary'
}), (0, _defineProperty2.default)(_VALIDATE_ICONS, VALIDATE_STATUS_ERROR, {
  name: 'ErrorIcon',
  color: 'orange'
}), _VALIDATE_ICONS);
exports.VALIDATE_ICONS = VALIDATE_ICONS;
var LOCALE = {
  noResultLabel: 'There is no result for {0}',
  loadOptions: 'Options are loading',
  recentSearch: 'Recent Searches',
  noRightKeywordLabel: 'Please enter right type of keyword',
  clear: 'Clear',
  searchFor: 'Search for'
};
exports.LOCALE = LOCALE;
var HIGHTLIGHT_COLOR = 'rgba(75, 79, 166, 0.2)';
exports.HIGHTLIGHT_COLOR = HIGHTLIGHT_COLOR;
var MAX_HEIGHT = 252;
exports.MAX_HEIGHT = MAX_HEIGHT;
var SCROLL_SPACE = 56;
exports.SCROLL_SPACE = SCROLL_SPACE;
var KEY_CODE = {
  ENTER: 13
};
exports.KEY_CODE = KEY_CODE;